import React, { useMemo, useCallback } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { SearchBar as RSKSearchBar } from '@uncinc/react-searchkit';
import { SearchBarProps as Type } from '@uncinc/react-searchkit/dist/components/SearchBar';

import { SCREEN_WIDE } from '../../../config/constants';
import Button from '../../Button';

import './style.scss';

export interface SearchBarProps extends Type {
  type?: 'primary' | 'secondary';
  className?: string;
}

const SearchBar = React.forwardRef<HTMLInputElement, SearchBarProps>((props, ref) => {
  const {
    type = 'primary',
    placeholder,
    buttonText,
    className,
    ...restProps
  } = props;

  const { t } = useTranslation();
  const { width } = useWindowDimensions();

  const classNames = c(`SearchBar--${type}`, className);
  const isMobileDesign = useMemo(() => width < SCREEN_WIDE, [width]);

  // Memoize the button to prevent re-renders, this causes focus loss from react-autosuggest.
  const SearchBarButton = useCallback((buttonProps: any) => (
    <Button
      {...buttonProps}
      icon="search"
      {...(isMobileDesign ? {
        variant: 'icon-only',
        ariaLabel: buttonText || t('buttons.search'),
      } : {})}
    >
      {buttonText || t('buttons.search')}
    </Button>
  ), [isMobileDesign, buttonText, t]);

  return (
    <RSKSearchBar
      {...restProps}
      ref={ref}
      className={classNames}
      placeholder={isMobileDesign ? t('components.search.search_bar.mobile_placeholder') : placeholder}
      title={t('components.search.search_bar.label')}
      button={SearchBarButton}
    />
  );
});

export default SearchBar;
